import type { FC } from "react";
import { useQuery } from "@apollo/client";
import { OpenSupportRequestsQuery } from "@/admin/entities/assistant";
import type {
  OpenSupportRequestsQueryType,
  OpenSupportRequestsQueryVariablesType,
} from "@/types/graphql/admin.generated";
import { OPEN_REQUESTS_LIMIT } from "../model/openRequests";
import { OpenSupportRequestsList } from "./OpenSupportRequestsList";

/** Только когда есть открытые обращения: при нуле, загрузке и ошибке карточки нет. */
export const OpenSupportRequestsCard: FC = () => {
  const { data } = useQuery<
    OpenSupportRequestsQueryType,
    OpenSupportRequestsQueryVariablesType
  >(OpenSupportRequestsQuery, {
    variables: { rowsPerPage: OPEN_REQUESTS_LIMIT },
    fetchPolicy: "cache-and-network",
  });
  const connection = data?.supportRequests;
  if (!connection || connection.count === 0) return null;
  return (
    <OpenSupportRequestsList rows={connection.nodes} count={connection.count} />
  );
};
